import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { User, userData } from '../../Storeredux/constants/actionTypes';
import { getEmployeeDashboardData } from '../../Services/hooks/Dashboard';
import { ObjectType } from '../../Services/constant/serviceType';
import { Link } from 'react-router-dom';
import propertyImage from '../../Assets/Images/propertyImage.png';
import { ReactComponent as Bed } from '../../Assets/Icons/bedcardIcon.svg';
import { ReactComponent as Shower } from '../../Assets/Icons/ShowerIcon.svg';
import { ReactComponent as Toilet } from '../../Assets/Icons/toiletIcon.svg';
import { ReactComponent as Home } from '../../Assets/Icons/home.svg';
import { dateFormat } from '../../Utils/dateFormat';
import { formatCurrency, formatCurrency2 } from '../../Utils/currencyFormat';


function Dashboard() {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const [dashboardData, setDashboardData] = useState<ObjectType>({});
  const [myProperties, setMyProperties] = useState<ObjectType>({});
  console.log('dashboard', dashboardData);

  const dash = async () => {
    const response = await getEmployeeDashboardData(user?.id);
    console.log(response, 'hgff');
    setDashboardData(response.result);
    setMyProperties(response.result.my_properties);
  };

  useEffect(() => {
    dash();
  }, []);
  return (
    <div className='overflow-scroll overflow-x-hidden'>
      <div className='w-11/12 md:w-11/12 lg:w-11/12 mx-auto  py-5 '>
        <div className={'flex w-full mx-auto py-10 gap-7 xl:flex-row flex-col'}>
          <div className={'w-full xl:w-6/12 rounded-xl flex flex-col gap-5 items-center py-0 p-3'}>
            <div className={'w-full rounded-xl flex flex-row gap-5 items-center py-0 h-40'}>
              <div
                className={'w-1/2 border border-custom-grey flex h-full flex-col justify-between gap-10 rounded-lg py-3 px-4'}
                style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
                <h1 className={'text-xs font-bold'}>
                  Amount Paid For Rent
                </h1>
                <p className={'font-bold text-lg'}>
                  {formatCurrency2(dashboardData?.paid_for_rent || '') || 0}
                </p>
              </div>
              <div
                className={'w-1/2 border border-custom-grey h-full flex flex-col justify-between gap-10 rounded-lg py-3 px-4'}
                style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
                <h1 className={'text-xs font-bold'}>
                  Paid for Mortgage
                </h1>
                <p className={'font-bold text-lg'}>
                  {formatCurrency2(dashboardData?.paid_for_mortgage || 0) || 0}
                </p>
              </div>
            </div>
            <div className={'w-full rounded-xl flex flex-row gap-5 items-center py-0 h-40'}>
              <div
                className={'w-1/2 text-white border border-custom-grey flex bg-[#AA1B03] flex-col justify-between h-full gap-10 rounded-lg py-3 px-4'}
                style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
                <h1 className={'text-xs font-bold'}>
                  Amount Left For Mortgage
                </h1>
                <p className={'font-bold text-lg'}>
                  {formatCurrency2(dashboardData?.left_for_mortgage || 0) || 0}
                </p>
              </div>
              <div
                className={'w-1/2 text-white border border-custom-grey flex flex-col bg-[#AA1B03] justify-between h-full gap-10 rounded-lg py-3 px-4'}
                style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
                <h1 className={'text-xs font-bold'}>
                  Amount Left For Rent
                </h1>
                <p className={'font-bold text-lg'}>
                  {formatCurrency2(dashboardData?.left_for_rent || 0) || 0}
                </p>
              </div>
            </div>
          </div>
          <div className={'xl:w-6/12 w-full py-3 px-4 border border-custom-grey rounded-lg'}
               style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
            <h1 className={'text-xs pb-3'}>My Properties</h1>
            <div className={'flex flex-1 h-full w-full flex-row items-center justify-center py-3 gap-5'}>
              {myProperties === null ?
                <div className={'flex flex-1 flex-col justify-center items-center h-full w-full'}>
                  <Home />
                  <p className={'font-bold text-sm py-4'}>Your Have No Property Yet</p>
                </div> :
                <>
                  {
                      <div className='rounded-3xl overflow-hidden w-fit bg-white border border-custom-grey'>
                        <div className='relative'>
                          <img src={propertyImage} alt='investment' className='w-full' />
                          <span
                            className={`absolute uppercase bg-white top-2 font-semibold left-2 rounded-full text-xs py-1 px-2.5 ${myProperties.noOfSlotAvailable === 0 ? 'text-red-500' : 'text-green-600'}`}>
                              {myProperties?.noOfSlotAvailable === 0 ? 'Sold Out' : 'Active'}
                          </span>
                        </div>
                        <div className='p-2'>
                          <h1 className='py-2 text-xs'>{myProperties?.property?.title}</h1>
                          <div className={'flex gap-2 items-center justify-between'}>
                            <div>
                              <p className={'text-xs text-custom'}>{myProperties?.property?.address}</p>
                              <div className={'flex gap-2 py-2'}>
                                <span
                                  className={'bg-custom-grey flex justify-between gap-1.5 py-1 px-1.5 w-fit rounded-3xl items-center text-xs'}>
                                  <span>
                                    <Bed />
                                  </span>
                                  <span>{myProperties?.property?.rooms}</span>
                                </span>
                                <span
                                  className={'bg-custom-grey flex justify-between gap-1.5 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                                  <span>
                                    <Shower />
                                  </span>
                                  <span>{myProperties?.property?.showers}</span>
                                </span>
                                <span
                                  className={'bg-custom-grey flex justify-between gap-1.5 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                                  <span>
                                    <Toilet />
                                  </span>
                                  <span>{myProperties?.property?.toilets}</span>
                                </span>
                              </div>
                            </div>
                            <div className="flex justify-end h-full gap-3.5">
                              <Link to={`/app/property/${myProperties.id}`}
                                    className="bg-custom-midnightgreen px-5 py-1 rounded text-white text-sm">
                                View
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                  }
                </>
              }
            </div>
          </div>
        </div>


        <div className=' py-2 border border-custom-grey rounded-custom'
             style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
          <h1 className=' text-sm lg:text-lg font-bold pb-6 px-3.5 '>
            Transaction History
          </h1>
          <table className='w-full'>
            <thead className='font-semibold text-xs bg-custom-light-green uppercase'>
            <tr className=''>
              <th className='py-4'>S/N</th>
              <th className={'md:table-cell hidden'}>Transaction id</th>
              <th>repayment date</th>
              <th>status</th>
              <th>amount Paid</th>
              {/*<th className={'md:table-cell hidden'}>Month</th>*/}
            </tr>
            </thead>
            {dashboardData?.transactions?.length !== 0 ?
              <tbody>
              {
                dashboardData?.transactions?.map((historyData: User, index: number) =>
                  <tr key={index} className='font-semibold text-xxs sm:text-xs text-center uppercase'>
                    <td className='py-4'>{historyData?.id}</td>
                    <td className='py-4'>{historyData?.transaction_id}</td>
                    <td className={'md:table-cell'}>{dateFormat(historyData?.end)}</td>
                    <td>{historyData?.status}</td>
                    <td>{formatCurrency(historyData?.amount)}</td>
                    {/*<td className={'md:table-cell hidden'}>{getTime(historyData?.created_at)}</td>*/}
                    {/*<td>{historyData?.type}</td>*/}
                  </tr>)
              }
              </tbody>
              :
              <tbody>
              <tr>
                <td colSpan={6} className=''>
                  <div className='flex flex-col justify-center items-center w-full py-16'>
                    <p className='text-sm pt-1'>No Transaction Yet </p>
                  </div>
                </td>
              </tr>
              </tbody>
            }
          </table>
        </div>

      </div>
    </div>
  );
}

export default Dashboard;
